import { createGlobalStyle } from 'styled-components';

import MyriadProRegular from '@/assets/fonts/myriad-pro-regular.ttf';
import Background from '@/assets/icons/cover-images/type-it.png';

const VariationsStyles = createGlobalStyle`
  @font-face {
      font-family: 'MyriadProRegular';
      src: url(${MyriadProRegular});
    }   
  
  .generated-images-holder-var28 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var28 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }
  .right-text-var28 {
    position: relative;
    overflow: hidden;
    height: 100%;
    background-color: white;
    line-height: 1.2;
    width: 50%;
    text-align: center;
    color: #000;
    font-family: MyriadProRegular;
    display: flex;
    font-weight: 400;
    align-items: center;
    justify-content: center;
    background: url(${Background}) no-repeat center center;
  }
  .right-text-inner-var28 {
    position: absolute;
    bottom: 46px;
    right: 54px;
    height: 310px;
    width: 492px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .half-image-var28 {
    width: 50%;
    height: 100%;
    object-fit: cover;
    position: relative;
    display: block;
  }
  .actual-photo-var28 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .actual-photo-var28--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
